// src/Pages/Owner/OwnerRegister/OwnerRegisterPage.jsx

import React, { useState, useEffect } from 'react';
import './OwnerRegisterPage.css';
import { useNavigate } from 'react-router-dom'; // 추가
import axios from 'axios';
import { uniqueId } from 'lodash';


export default function OwnerRegisterPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordCheck, setPasswordCheck] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState({ part1: '', part2: '', part3: '' });
  const [agree, setAgree] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [generatedCode, setGeneratedCode] = useState(null);
  const [cooldown, setCooldown] = useState(0);
  const [verifyCode, setVerifyCode] = useState('');
  const [isCodeVerified, setIsCodeVerified] = useState(false);
  const [codeError, setCodeError] = useState('');
  const [passwordMismatch, setPasswordMismatch] = useState(false);
  const [businessCard, setBusinessCard] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL || 'https://fastapi-backend-657266059621.asia-northeast1.run.app';


  const fullPhoneNumber = `${phone.part1}${phone.part2}${phone.part3}`;
  const navigate = useNavigate(); 
  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [cooldown]);
  useEffect(() => {
    setPasswordMismatch(password && passwordCheck && password !== passwordCheck);
  }, [password, passwordCheck]);
  const handlePhoneChange = (e, field) => {
    setPhone({ ...phone, [field]: e.target.value });
  };
  
  const handleSendCode = async () => {
    if (cooldown > 0) return;
    try {
      const code = Math.floor(100000 + Math.random() * 900000);
      setGeneratedCode(code);

      const messageData = {
        message: {
          to: fullPhoneNumber,
          from: '07080645411',
          text: `인증 번호: ${code}\n Welcome to H2P!`,
          type: 'SMS',
        },
      };

      const date = new Date().toISOString();
      const salt = uniqueId();
      const combinedString = date + salt;
      const apiKey = 'NCSLENCCTLRPA43Q';
      const apiSecret = 'QOAXN2SL1GYHWM3XOSPX08OKMBJCQ6JO';
      const signature = await getSignature(apiSecret, combinedString);

      const headers = {
        Authorization: `HMAC-SHA256 apiKey=${apiKey}, date=${date}, salt=${salt}, signature=${signature}`,
        'Content-Type': 'application/json',
      };

      await axios.post('https://api.coolsms.co.kr/messages/v4/send', messageData, { headers });
      setIsCodeSent(true);
      setCooldown(60);
      setCodeError('');
    } catch (err) {
      alert('인증번호 전송에 실패했습니다.');
    }
  };
  const getSignature = async (apiSecret, msg) => {
    const encoder = new TextEncoder();
    const keyData = encoder.encode(apiSecret);
    const key = await crypto.subtle.importKey(
      'raw',
      keyData,
      { name: 'HMAC', hash: 'SHA-256' },
      false,
      ['sign']
    );

    const msgData = encoder.encode(msg);
    const signature = await crypto.subtle.sign('HMAC', key, msgData);

    return Array.from(new Uint8Array(signature))
      .map((b) => ('00' + b.toString(16)).slice(-2))
      .join('');
  };
  const handleVerifyCode = () => {
    if (verifyCode === generatedCode.toString()) {
      setIsCodeVerified(true);
      setCodeError('');
    } else {
      setIsCodeVerified(false);
      setCodeError('인증번호가 일치하지 않습니다.');
    }
  };
  const handleBusinessCardUpload = (e) => {
    setBusinessCard(e.target.files[0]);
  };
  const isFormValid =
    email &&
    password.length >= 8 &&
    password === passwordCheck &&
    name &&
    phone.part1 &&
    phone.part2 &&
    phone.part3 &&
    agree &&
    isCodeVerified &&
    businessCard;

   const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) {
        alert('모든 입력을 정확히 작성하고 인증을 완료해주세요.');
        return;
      }
      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);
      formData.append('name', name);
      formData.append('phone', fullPhoneNumber);
      formData.append('file', businessCard);  
      
      try {
        await axios.post(`${API_URL}/api/owner/register`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        alert('등록이 완료되었습니다. 1~2일 내 이메일로 안내드릴 예정입니다.');
        navigate('/owner');

      } catch (err) {
        if (err.response?.data?.detail === "이미 가입된 이메일입니다.") {
          alert('이미 가입된 이메일입니다.');
        } else {
          alert('등록 중 오류가 발생했습니다.');
        }
      }
    };

  return (
    <div className="owner-register-wrapper">
    <div className="owner-register-container">
      <h1 className="title">관리자 계정 등록</h1>
      <p className="subtitle">대표님 계정을 아래 항목에 맞게 작성해 주세요.</p>

      <form onSubmit={handleSubmit} className="register-form">
      <label className="form-label">이메일 *</label>
      <input 
        type="email" 
        placeholder="이메일 주소를 입력하세요" 
        value={email} 
        onChange={(e) => setEmail(e.target.value)} 
        className="register-form-input"
        required 
      />

        <div className="info-box">
        입력된 이메일은 대표 계정으로 지정되며, 추후에는 관리자 계정 추가가 가능할 예정입니다.
        </div>

        <label className="form-label">비밀번호 *</label>
        <input 
          type="password" 
          placeholder="8자 이상 영문, 숫자, 특수문자 포함" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          className="register-form-input"
          required 
        />


        <label className="form-label">비밀번호 확인 *</label>
        <input 
          type="password" 
          placeholder="비밀번호를 한 번 더 입력하세요" 
          value={passwordCheck} 
          onChange={(e) => setPasswordCheck(e.target.value)} 
          className="register-form-input"
          required 
        />
        {passwordMismatch && <div className="error-text">비밀번호가 일치하지 않습니다.</div>}

        <label className="form-label">대표님 성함 *</label>
        <input 
          type="text" 
          placeholder="이름을 입력해 주세요" 
          value={name} 
          onChange={(e) => setName(e.target.value)} 
          className="register-form-input"
          required 
        />


        <label className="form-label">휴대폰 번호 *</label>
        <div className="phone-input">
          <input 
            type="text" 
            maxLength="3" 
            value={phone.part1} 
            onChange={(e) => handlePhoneChange(e, 'part1')} 
            className="phone-input-field"
            required 
          />
          -
          <input 
            type="text" 
            maxLength="4" 
            value={phone.part2} 
            onChange={(e) => handlePhoneChange(e, 'part2')}
            className="phone-input-field" 
            required 
          />
          -
          <input 
            type="text" 
            maxLength="4" 
            value={phone.part3} 
            onChange={(e) => handlePhoneChange(e, 'part3')} 
            className="phone-input-field"
            required 
          />
          <button 
            className="send-code-button" 
            type="button" 
            onClick={handleSendCode} 
            disabled={cooldown > 0}
          >
            {cooldown > 0 ? `재전송 (${cooldown}s)` : isCodeSent ? '재전송' : '인증 번호 받기'}
          </button>
        </div>
        {isCodeSent && (
          <div className="verify-code-section">
            <label className="form-label">인증번호 입력 *</label>
            <input 
              type="text" 
              placeholder="전송된 인증번호를 입력하세요" 
              value={verifyCode} 
              onChange={(e) => setVerifyCode(e.target.value)} 
              className="register-form-input"
              required 
            />
            <button 
              type="button" 
              onClick={handleVerifyCode} 
              className={`verify-button ${isCodeVerified ? 'verified' : codeError ? 'failed' : ''}`}
            >
              인증 확인 {isCodeVerified && '✔'}
            </button>
            {codeError && <div className="error-text">{codeError}</div>}
          </div>  
        )}
        <label className="form-label">명함 이미지 첨부 *</label>
        <div className="file-upload-wrapper">
        <input
          id="businessCardUpload"
          type="file"
          accept="image/*"
          onChange={handleBusinessCardUpload}
          className="file-input"
          required
        />
        <label htmlFor="businessCardUpload" className="upload-label">파일 선택</label>
        {businessCard && <span className="file-name">{businessCard.name}</span>}
        </div>
        <div className="info-box guide-text">
        입력하신 정보로 <strong>1~2일 내 이메일로 안내</strong>드릴 예정입니다.
      </div>

        <div className="terms">
          <label>
            <input 
              type="checkbox" 
              checked={agree} 
              onChange={(e) => setAgree(e.target.checked)} 
              className="checkbox-input"
              required 
            />
            (필수) 약관에 동의합니다.
          </label>
        </div>

        <button 
          type="submit" 
          disabled={!isFormValid} 
          className={`submit-button ${!isFormValid ? 'disabled' : ''}`}
        >
          다음 단계
        </button>
      </form>
    </div>
    </div>
  );
}
